import { render, staticRenderFns } from "./OutfitSelector.vue?vue&type=template&id=1760866d&scoped=true&"
import script from "./OutfitSelector.vue?vue&type=script&lang=js&"
export * from "./OutfitSelector.vue?vue&type=script&lang=js&"
import style0 from "./OutfitSelector.vue?vue&type=style&index=0&id=1760866d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1760866d",
  null
  
)

export default component.exports